import { LayaGL } from "../../layagl/LayaGL";
import { BufferUsage } from "../../RenderEngine/RenderEnum/BufferTargetType";
import { IndexFormat } from "../../RenderEngine/RenderEnum/IndexFormat";
export class Graphic2DDynamicVIBuffer {
    get vertexBuffer() {
        return this._vertexBuffer;
    }
    get indexBuffer() {
        return this._indexBuffer;
    }
    get bufferState() {
        return this._bufferState;
    }
    constructor(vertexBlockSize, vertexDeclaration) {
        this._vertexViews = [];
        this._indexBufferLength = 0;
        this._indexBufferMaxLength = 0;
        this._vertexFreeBlocks = [];
        this._vertexBlockSize = vertexBlockSize;
        this._vertexBuffer = LayaGL.renderDeviceFactory.createVertexBuffer(BufferUsage.Dynamic);
        this._wholeVertex = LayaGL.render2DRenderPassFactory.create2DGraphicVertexBuffer();
        this._wholeVertex.buffer = this._vertexBuffer;
        this._indexBuffer = LayaGL.renderDeviceFactory.createIndexBuffer(BufferUsage.Dynamic);
        this._indexBuffer.indexType = IndexFormat.UInt16;
        this._wholeIndex = LayaGL.render2DRenderPassFactory.create2DGraphicIndexBuffer();
        this._wholeIndex.buffer = this._indexBuffer;
        this._bufferState = LayaGL.renderDeviceFactory.createBufferState();
        this._vertexBuffer.vertexDeclaration = vertexDeclaration;
        this._vertexDeclaration = vertexDeclaration;
        this._vertexStride = vertexDeclaration.vertexStride;
        this._vertexElementLength = this._vertexStride / 4;
        this._vertexBlockLength = this._vertexBlockSize * this._vertexElementLength;
        this._bufferState.applyState([this._vertexBuffer], this._indexBuffer);
        let vbsize = Graphic2DDynamicVIBuffer.MAX_VERTEX / this._vertexBlockSize;
        this.resizeVertexBuffer(vbsize);
        let ibsize = Graphic2DDynamicVIBuffer.DEFAULT_BLOCK_SIZE;
        this.resizeIndexBuffer(ibsize);
        this._tempVertexData = new Float32Array(this._vertexBlockSize * this._vertexElementLength);
    }
    resizeVertexBuffer(blockSize) {
        let byteLength = blockSize * this._vertexBlockSize * this._vertexStride;
        this._wholeVertex.resetData(byteLength);
        this._vertexBuffer.setDataLength(byteLength);
        this._canVBlockCount = blockSize;
    }
    resizeIndexBuffer(size) {
        let byteLength = size * 2;
        this._wholeIndex.resetData(byteLength);
        this._indexBuffer._setIndexDataLength(byteLength);
        this._indexBufferMaxLength = size;
    }
    indexExtendBlock(length) {
        let nMaxLength = Math.ceil((this._indexBufferLength + length) / Graphic2DDynamicVIBuffer.DEFAULT_BLOCK_SIZE) * Graphic2DDynamicVIBuffer.DEFAULT_BLOCK_SIZE;
        this.resizeIndexBuffer(nMaxLength);
    }
    checkVertexBuffer(vertexCount) {
        let requiredBlocks = Math.ceil(vertexCount / this._vertexBlockSize);
        let requiredExtendBlockCount = requiredBlocks - (this._vertexFreeBlocks.length + (this._canVBlockCount - this._vertexViews.length));
        if (requiredExtendBlockCount > 0) {
            return null;
        }
        let usedBlocks = [];
        let usedViews = [];
        let remainingBlocks = requiredBlocks;
        while (remainingBlocks > 0 && this._vertexFreeBlocks.length > 0) {
            let block = this._vertexFreeBlocks.shift();
            usedBlocks.push(block);
            usedViews.push(this._vertexViews[block]);
            remainingBlocks--;
        }
        while (remainingBlocks > 0) {
            let newBlockIndex = this._vertexViews.length;
            usedBlocks.push(newBlockIndex);
            let view = LayaGL.render2DRenderPassFactory.create2DGraphicVertexDataView(this._wholeVertex, newBlockIndex * this._vertexBlockLength, this._vertexBlockLength, this._vertexElementLength);
            this._vertexViews[newBlockIndex] = view;
            usedViews.push(view);
            remainingBlocks--;
        }
        return { buffer: this, vertexViews: usedViews, vertexBlocks: usedBlocks };
    }
    checkIndexBuffer(length) {
        let view;
        if (this._indexBufferLength + length > this._indexBufferMaxLength) {
            this.indexExtendBlock(length);
        }
        view = LayaGL.render2DRenderPassFactory.create2DGraphicIndexDataView(this._wholeIndex, length);
        this._indexBufferLength += length;
        return view;
    }
    _releaseBlocks(blocks, list, freeBlocks) {
        if (!blocks || blocks.length === 0)
            return;
        freeBlocks.push(...blocks);
    }
    releaseVertexBlocks(blocks) {
        this._releaseBlocks(blocks, this._vertexViews, this._vertexFreeBlocks);
    }
    releaseIndexView(indexView) {
        this._indexBufferLength -= indexView.length;
        this._wholeIndex.removeDataView(indexView);
    }
    clear() {
        this._vertexViews.forEach(view => view = null);
        this._vertexFreeBlocks = [];
    }
    destroy() {
        this.clear();
        this._vertexBuffer.destroy();
        this._indexBuffer.destroy();
    }
}
Graphic2DDynamicVIBuffer.MAX_VERTEX = 32768;
Graphic2DDynamicVIBuffer.DEFAULT_BLOCK_SIZE = 1024;
